export default __webpack_public_path__ + "static/media/fmd2.8d0cc99b.jpeg";